import { Button, ButtonProps } from '@chakra-ui/react';
import { RefAttributes } from 'react';

export const RoundedButton = ({ children, ...rest }: ButtonProps & RefAttributes<HTMLButtonElement>) => {
  return (
    <Button borderRadius="full" px={3} {...rest}>
      {children}
    </Button>
  );
};
